<template>
  <el-dialog
    :visible.sync="showModal"
    :center="true"
    class="pricebreakdown-modal"
    @closed="emitEvent">
    <div
      v-loading="loading"
      class="pricebreakdown"
    >
      <h5>Your monthly price breakdown</h5>
      <div v-if="invoiceDetail">
        <el-row
          type="flex"
          justify="space-between"
          align="middle">
          <div>Monthly subscription</div>
          <div>{{ invoiceDetail.chargeAmount | amountFilter(invoiceDetail.currency, true) }}</div>
        </el-row>
        <el-row
          v-if="invoiceDetail.referralDiscount"
          type="flex"
          justify="space-between"
          align="middle">
          <div>Referral Discounts</div>
          <div>- {{ invoiceDetail.referralDiscount | amountFilter(invoiceDetail.currency, true) }}</div>
        </el-row>
        <el-row
          v-if="invoiceDetail.discount"
          type="flex"
          justify="space-between"
          align="middle">
          <div>Discounts</div>
          <div>{{ invoiceDetail.discount | amountFilter(invoiceDetail.currency, true) }}</div>
        </el-row>
        <el-row
          type="flex"
          justify="space-between"
          align="middle">
          <div>Tax</div>
          <div v-if="!nextCharge">{{ invoiceDetail.taxAmount | amountFilter(invoiceDetail.currency, true) }}</div>
          <div v-if="nextCharge">{{ invoiceDetail.chargeAmount | taxFilter(invoiceDetail.currency) }}</div>
        </el-row>
        <el-row
          type="flex"
          align="middle"
          justify="space-between"
          class="total">
          <div>Total</div>
          <div>{{ total | amountFilter(invoiceDetail.currency, true) }}</div>
        </el-row>
      </div>
      <el-button
        type="primary"
        class="action-button"
        @click="emitEvent"
      >
        Close
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import Subscription from '../../services/Subscription';

export default {
  name: 'PriceBreakdownModal',
  props: {
    show_modal: {
      default: false,
      type: Boolean,
    },
    invoice_id: {
      default: '',
      type: String,
    },
    invoiceDetails: {
      type: Object,
      default: () => {},
    },
    nextCharge: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      showModal: this.show_modal,
      subscriptionProvider: new Subscription(),
      invoiceDetail: {
        chargeAmount: 0,
        taxAmount: 0,
        discount: 0,
        referralDiscount: 0,
      },
      loading: false,
    };
  },
  computed: {
    inVoiceId() {
      return this.invoice_id;
    },
    total() {
      return parseFloat(this.invoiceDetail.chargeAmount) + parseFloat(this.invoiceDetail.taxAmount || 0) + parseFloat(this.invoiceDetail.discount || 0) - parseFloat(this.invoiceDetail.referralDiscount || 0);
    },
  },
  watch: {
    show_modal(newVal) {
      this.showModal = newVal;
    },
    inVoiceId(newVal) {
      if (newVal !== '') {
        this.fetchInvoiceDetails();
      }
    },
    invoiceDetails(newVal) {
      if (newVal) {
        this.invoiceDetail = newVal;
      }
    },
  },
  methods: {
    emitEvent() {
      this.$emit('close');
    },
    fetchInvoiceDetails() {
      this.loading = true;
      this.subscriptionProvider.getTransactionDetails(this.invoice_id).then((resp) => {
        this.loading = false;
        if (resp && resp.invoice_details) {
          this.invoiceDetail = resp.invoice_details;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss">
.pricebreakdown-modal {
  .el-dialog {
    border: 1px solid #BABABA;
    border-radius: 8px;

    .el-dialog__header {
      padding: 0px;
      .el-dialog__headerbtn .el-dialog__close {
        font-size: 24px;
        color: #666666;
      }
    }

    @media (max-width: 900px) {
      width: 75%;
    }

    @media (max-width: 567px) {
      width: 90%;
    }

    .el-dialog__body {
      padding: 0px;
      color: #111111;

      .pricebreakdown {
        padding: 50px 120px;

        @media (max-width: 1100px) {
          padding: 20px 50px;
        }

        @media (max-width: 567px) {
          padding: 30px 20px;
        }

        h5 {
          font-size: 24px;
          font-weight: bold;
          line-height: 28px;
          margin-bottom: 32px;
        }

        p {
          margin-bottom: 30px;
        }

        .el-button {
          margin-top: 12px;
        }

        .total {
          margin-top: 16px;
          padding: 16px 0;
          border-top: 1px solid #BABABA;
        }

        .el-row {
          font-size: 16px;
          line-height: 20px;
          margin-bottom: 18px;
        }

        [class*="el-col-"] {
          margin-bottom: 3px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/subscription/PricebreakdownModal.vue